import React, { useEffect, useState } from "react";
import { Select, MenuItem } from "@mui/material";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { getDashboardColors } from "../../utils/dashboardColors";

ChartJS.register(ArcElement, Tooltip, Legend);

const OverallScore = ({ dashboard, masteryScore = [], overallMastery }) => {
  const { accentColor, chartRemainderColor } = getDashboardColors();

  const [selectedSubject, setSelectedSubject] = useState("overall");
  const [cardData, setCardData] = useState([
    { name: "Direct", value: "0%", key: "direct" },
    { name: "Critical Thinking", value: "0%", key: "critical_thinking" },
    { name: "Reasoning", value: "0%", key: "reasoning" },
    { name: "Application", value: "0%", key: "application" },
  ]);

  const selectedData =
    selectedSubject === "overall"
      ? overallMastery
      : masteryScore?.find((data) => data.subject_key === selectedSubject);

  const doughnutData = {
    datasets: [
      {
        data: [
          selectedData?.total_percentage || 0,
          100 - (selectedData?.total_percentage || 0),
        ],
        backgroundColor: [accentColor, chartRemainderColor],
        borderWidth: 0,
        circumference: 270,
        rotation: 225,
        spacing: 2,
        borderRadius: 8,
      },
    ],
  };

  const config = {
    cutout: "92%",
    responsive: true,
    maintainAspectRatio: false,
    radius: "90%",
    animation: {
      animateRotate: true,
      animateScale: true,
      duration: 2000,
      easing: "easeInOutQuart",
    },
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
  };

  useEffect(() => {
    const source =
      selectedSubject === "overall" ? overallMastery : selectedData;

    if (!source) return;

    setCardData((prev) =>
      prev.map((skill) => ({
        ...skill,
        value: `${source[skill.key]?.percentage || 0}%`,
      })),
    );
  }, [overallMastery, selectedData, selectedSubject]);

  return (
    <div className="overall-score-main d-flex-col">
      <div>
        {" "}
        <div
          style={{
            color: "var(--dashboard-side-title-color)",
            fontWeight: "700",
          }}
        >
          Progress Based Mastery
        </div>
        <div className="overall-score-body-wrapper">
          <div className="overall-score-body d-flex-col gap-8">
            {/* {!dashboard && (
            <div className="overall-score-body-top">
              <Select
                value={selectedSubject}
                onChange={(e) => setSelectedSubject(e.target.value)}
                size="small"
                sx={{
                  minWidth: 200,
                  borderRadius: "10px",
                  bgcolor: "#F9FAFB",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#DFE3E8",
                  },
                }}
              >
                <MenuItem value="overall">Overall</MenuItem>
                {masteryScore?.map((subject) => (
                  <MenuItem
                    key={subject.subject_key}
                    value={subject.subject_key}
                  >
                    {subject.subject_name}
                  </MenuItem>
                ))}
              </Select>
            </div>
          )} */}

            <div className="overall-score-body-bottom">
              <Doughnut data={doughnutData} options={config} />
              <div className="overall-score-container d-flex-col">
                <span className="overall-your-score-text">
                  Your Mastery Score
                </span>
                <span className="overall-your-mark-text">
                  {selectedData?.total_percentage || 0} %
                </span>
              </div>
            </div>
          </div>
          <div className="overall-score-cards">
            {cardData?.map((newData, index) => (
              <div className="single-mastery-card" key={index}>
                <div className="single-mastery-card-value">{newData.value}</div>
                <div className="single-mastery-card-name">{newData.name}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverallScore;
